import React from 'react';

import { bemCssModules, getTestId } from '@utils';

import Spinner from '@components/Spinner';

import style from './LoaderLayout.scss';

const cn = bemCssModules(style, 'LoaderLayout');
const ti = getTestId('LoaderLayout');

export type TLoaderLayout = {
  isLoading?: boolean;
  height?: string;
  size?: number;
};

const LoaderLayout: CustomFC<TLoaderLayout> = props => {
  const { className, children, isLoading, height, size } = props;

  if (!isLoading) return <>{children}</>;
  return (
    <div className={cn(null, [className])} data-testid={ti()} style={{ height }}>
      <Spinner size={size} />
    </div>
  );
};

export default LoaderLayout;
